import cookie from 'react-cookies';

import axios from 'axios';

import { apiBaseUrl } from './api';

import TenantConfig from '../config';
import mock from '../mock/api-payload.json';
import mockDetails from '../mock/loan-details-payload.json';
import mockPaymentInstrument from '../mock/loan-instruments-payload.json';
import mockPaymentInstrumentCreate from '../mock/loan-payment-instrument-create.json';
import mockLoanStatements from '../mock/loan-statements-payload.json';
import mockOneTimePaymentInfo from '../mock/one-time-payment-payload.json';
import mockPaymentHistory from '../mock/payment-history-payload.json';
import mockPaymentMethods from '../mock/payment-methods-payload.json';

export const getLoans = async () => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mock);
  }
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(
    `${apiBaseUrl}/sbl-servicing/loans?page=1${
      TenantConfig?.dashboard?.fetchLoanDetails ? '&loanDetail=false' : ''
    }`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getLoanDetails = async (id) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockDetails);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getLoanActivities = async (id) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/recent-activity`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getLoanPaymentHistory = async (id) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockPaymentHistory);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/payment-history`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getLoanPaymentMethods = async (id) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockPaymentMethods);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/payment-methods`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getPaymentInstrument = async (payeeId, paymentInstrumentId) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(
    `${apiBaseUrl}/sbl-servicing/payees/${payeeId}/payment-instruments/${paymentInstrumentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getPaymentInstrumentList = async (payeeId) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${payeeId}/payment-instruments`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getPaymentInstrumentByLoan = async (id) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockPaymentInstrument);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/payment-instruments`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const switchPaymentInstrumentForLoan = async (data, loanId) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.put(`${apiBaseUrl}/sbl-servicing/loans/${loanId}/auto-payment-instrument-id`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const sendPaymentWithInstrument = async (
  loanId,
  { paymentAmount, financialInstrumentId, paymentNotes }
) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/sbl-servicing/loans/${loanId}/one-time-payment-with-instrument`,
    {
      paymentAmount,
      paymentNotes,
      financialInstrumentId,
      accountReferenceNo: 0,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const createPaymentInstrument = async (data, payeeId) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockPaymentInstrumentCreate);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.post(`${apiBaseUrl}/sbl-servicing/payees/${payeeId}/payment-instruments`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getLoanStatements = async (id) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockLoanStatements);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/statements`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getStatementDetails = async (id, statementId) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve({ data: '' });
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/statements/${statementId}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const sendPayment = async (
  id,
  { paymentAmount, paymentDate, accountReferenceNo, routingNumber, accountNumber }
) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.post(
    `${apiBaseUrl}/sbl-servicing/loans/${id}/ach-payment`,
    {
      paymentAmount,
      paymentDate,
      accountReferenceNo,
      routingNumber,
      accountNumber,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
export const sendDrawDown = async (id, { paymentAmount }) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/sbl-servicing/loans/${id}/draw-down`,
    {
      requestedDrawAmount: paymentAmount,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const sendDrawDownConfirmation = async (id, { paymentAmount, disbursedAmount }) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.post(
    `${apiBaseUrl}/sbl-servicing/loans/${id}/draw-down`,
    {
      requestedDrawAmount: paymentAmount,
      disbursedAmount: disbursedAmount,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const sendTransferOut = async (id) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/transfer-out`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const sendTransferOutConfirmation = async (id, transferOutResponse) => {
  const token = cookie.load('lendistry_tokens_access');
  return axios.post(
    `${apiBaseUrl}/sbl-servicing/loans/${id}/transfer-out-confirm`,
    transferOutResponse,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getOneTimePaymentInfo = async (id) => {
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    return Promise.resolve(mockOneTimePaymentInfo);
  }
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/one-time-payment-info`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getScheduledOneTimePayment = async (id) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.get(`${apiBaseUrl}/sbl-servicing/loans/${id}/ach-payment`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const removeScheduledOneTimePayment = async (id, payload) => {
  const token = cookie.load('lendistry_tokens_access');

  return axios.delete(`${apiBaseUrl}/sbl-servicing/loans/${id}/ach-payment`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  });
};
